import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/registry';
import { PageHeader } from '@redturtle/iovisit-theme/components/Views';
import Breadcrumbs from '@redturtle/iovisit-theme/components/layout/Breadcrumbs/Breadcrumbs.jsx';

const LeadImage = () => {
  const content = useSelector((state) => state.content.data ?? {});
  const location = useLocation();
  const leadConfig = config.settings.iovisit.leadimage;

  const notFoundPage =
    useSelector((state) => state.content?.get?.error?.status) === 404;
  const SmallHeaderFor = leadConfig.sizeSmall.contentTypes ?? [];
  const NoLeadImageFor = leadConfig.hideFor ?? [];

  const normalizedNonContentRoutes = config.settings.nonContentRoutes.map(
    (item) => {
      if (item.test) {
        return item;
      } else {
        return new RegExp(item + '$');
      }
    },
  );

  const isNonContentRoutes = normalizedNonContentRoutes.some((rx) =>
    rx.test(location.pathname),
  );

  if (content && !isNonContentRoutes) {
    const contentType = content['@type'];
    const image = content?.image?.scales?.leadimage;
    const videoUrl = content?.video?.download;
    const videoMimeType = content?.video?.['content-type'];

    if (NoLeadImageFor.indexOf(contentType) >= 0) {
      return null;
    }

    let size = 'default';
    if (SmallHeaderFor.indexOf(contentType) > 0 || notFoundPage) {
      size = 'small';
    }

    let description = content.image_caption;

    // Determina le classi
    const hasMedia = !!image || !!videoUrl;
    const classes = [
      'leadimage',
      videoUrl ? 'leadvideo' : '',
      `size-${size}`,
      !hasMedia ? 'bg-primary' : '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div className={classes}>
        {videoUrl ? (
          <video
            loop={true}
            muted={true}
            autoPlay={true}
            poster={image?.download ? flattenToAppURL(image.download) : null}
          >
            <source type={videoMimeType} src={flattenToAppURL(videoUrl)} />
          </video>
        ) : image ? (
          <img
            src={flattenToAppURL(image.download)}
            alt={content?.image_caption ?? ''}
            loading="lazy"
          />
        ) : null}
        <div className="leadimage-content">
          <div className="ui container leadimage-title">
            <Breadcrumbs />
            {content['@type'] !== 'File' && <PageHeader content={content} />}
            {description && (
              <div className="lead-caption caption">{description}</div>
            )}
            <SlotRenderer name="leadimage-more" content={content} />
          </div>
        </div>
      </div>
    );
  }

  return <SlotRenderer name="leadimage" content={content} />;
};

export default LeadImage;
